import { useRef } from 'react';
import { FlagIcon } from 'react-flag-kit';
import { default as Stack } from '@mui/material/Stack';
import { DropdownMenu } from 'components/dropdown-menu';
import { AppLocale, getLocaleLanguage, getTrans } from 'modules/i18n';
import { mapFlagCode } from '../constants';
import { MenuItem } from './MenuItem';

type Props = {
  onSelect?: (locale: AppLocale) => Promise<void>;
};

export const Switcher = ({ onSelect }: Props) => {
  const appLocale = getLocaleLanguage();
  /**
   * Shared between both `MenuItem`s on purpose: the dropdown stays open across each item's own
   * `await initIntl(...)`, so without a lock that BOTH items check, clicking the other option
   * before the first click's own switch finishes would start a second, independent one — two
   * concurrent `setCurrentLocale`/`initIntl` calls racing, and whichever `onSelect` resolves last
   * reloading over the other's.
   */
  const selectingRef = useRef(false);

  const icon = () => (
    <FlagIcon
      code={mapFlagCode[appLocale]}
      size={20}
      width={28}
      style={{ borderRadius: 3 }}
    />
  );

  return (
    <DropdownMenu icon={icon} ariaLabel={getTrans('language.switcher.label')}>
      <Stack sx={{ p: 1 }}>
        <MenuItem
          label={getTrans('language.english')}
          locale={AppLocale.en_US}
          onSelect={onSelect}
          selectingRef={selectingRef}
        />
        <MenuItem
          label={getTrans('language.german')}
          locale={AppLocale.de_DE}
          onSelect={onSelect}
          selectingRef={selectingRef}
        />
      </Stack>
    </DropdownMenu>
  );
};
